import { render } from "./category-en.vue?vue&type=template&id=193a832a&scoped=true"
import script from "./category-en.vue?vue&type=script&lang=js"
export * from "./category-en.vue?vue&type=script&lang=js"

import "./category-en.vue?vue&type=style&index=0&id=193a832a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193a832a"]])

export default __exports__